import { Brush } from "@/components/organisms/Brush";
import { generateRandomEventData } from "@/components/organisms/Brush/Brush.utils";
import { useDisabledOverscroll } from "@/hooks/useDisabledOverscroll";
import { useCallback, useEffect, useState, type CSSProperties } from "react";

export default function Page() {
  const [isClientSide, setIsClientSide] = useState(false);

  useEffect(() => {
    setIsClientSide(true);
  }, []);

  useDisabledOverscroll();

  // Generate random event data
  const randomEvents = generateRandomEventData();
  const maxEventValue = 100;

  // Animation frame callback
  const handleAnimationFrame = useCallback(
    (data: {
      currentTime: number;
      cursorTime: number;
      startTime: number;
      endTime: number;
      duration: number;
      position: number;
      mode: "live" | "archive";
      isPaused: boolean;
      isCatchingUp: boolean;
      width: number;
    }) => {
      // console.log(data);
    },
    [],
  );

  // Cache the renderEvent function so it is stable across renders
  const renderEvent = useCallback((event: any, width: number) => {
    // Optionally remove or keep the console.log for debugging
    // console.log(event);
    const percentage = (event.value / maxEventValue) * 100;
    return (
      <div
        className="h-(--height) w-(--width) bg-[#3434ef] rounded-[2px]"
        style={
          {
            "--height":
              Number(`${percentage}%`) <= 1
                ? `${Number(`${percentage}%`) * 100}%`
                : `${percentage}%`,
            "--width":
              width / 200 <= 1 && width / 200 !== 0
                ? `${(width / 200) * 100}%`
                : `${width / 200}px`,
          } as CSSProperties
        }
      />
    );
  }, []);

  if (!isClientSide) return null;

  return (
    <div className="w-full h-full p-4">
      <div className="flex flex-col">
        <div className="[border-width:1px] [border-style:solid] border-border rounded-sm">
          <Brush
            duration={10}
            events={randomEvents}
            renderEvent={renderEvent}
            onAnimationFrame={handleAnimationFrame}
          />
        </div>
      </div>
    </div>
  );
}
